import {
  LinearProgress,
  Card,
  CardContent,
  Typography,
  Grid,
  Tooltip,
  IconButton,
  Stack,
} from "@mui/material";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridPagination,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import ResponsiveDataGrid from "../../../../../../components/MobileList/ResponsiveDataGrid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { JReports } from "../../../../../../app/slices/jomla/reportsSlice";
import DateRangepicker from "../../../../../../helpers/dateRangePicker";
import dayjs from "dayjs";
import { MdOutlineClear } from "react-icons/md";
import { SelectJItem } from "../../../../../../components/Selectors/jomla/SelectJItem";
import { JItems } from "../../../../../../app/slices/jomla/itemsSlice";

const SoldJItems = () => {
  const dispatch = useDispatch();

  const [search, setSearch] = useState({
    startDate: dayjs().format("YYYY-MM-01"),
    endDate: dayjs().format("YYYY-MM-DD"),
    j_item_id: null,
  });

  const _SoldJItems = useSelector((state) => state.jReports.soldJItems);
  const loading = useSelector((state) => state.jReports.loading);
  const reportTypes = useSelector((state) => state.jReports.reportTypes);
  const _JItems = useSelector((state) => state.JItems.JItemsList.data);

  const columns = [
    {
      field: "index",
      headerName: "#",
      flex: 0.2,
    },
    {
      field: "j_item_name",
      headerName: "اسم المنتج",
      flex: 1,
    },
    {
      field: "j_item_code",
      headerName: "Code",
      flex: 0.5,
    },
    {
      field: "created_at",
      headerName: "تاريخ الشراء",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography>
            {dayjs(params.row.created_at).format("YYYY-MM-DD")}
          </Typography>
        );
      },
    },
    {
      field: "j_invoice_no",
      headerName: "رقم الفاتورة",
      flex: 1,
    },
    {
      field: "count",
      headerName: "العدد",
      flex: 1,
    },
    {
      field: "total_price",
      headerName: "السعر",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography>{params.row.total_price?.toLocaleString()}</Typography>
        );
      },
    },
    {
      field: "j_supplier",
      headerName: "المورد",
      flex: 1,
    },
    {
      field: "expiry_date",
      headerName: "تاريخ النفاذ",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography>
            {params.row.expiry_date
              ? dayjs(params.row.expiry_date).format("YYYY-MM-DD")
              : "--"}
          </Typography>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(
      JReports.soldJItems({
        start_date: search.startDate,
        end_date: search.endDate,
        j_item_id: search.j_item_id,
      })
    );
  }, [dispatch, reportTypes, search]);

  useEffect(() => {
    dispatch(JItems.getAllList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarExport
        csvOptions={{
          fileName: "حركات الشراء | نظام دجلة",
          utf8WithBom: true,
        }}
      />
    </GridToolbarContainer>
  );

  function CustomFooter() {
    return (
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography color="primary" sx={{ marginX: 2 }}>
          القيمة الكلية : {_SoldJItems.total_amount?.toLocaleString()} (IQD)
        </Typography>
        <GridPagination />
      </Stack>
    );
  }

  return (
    <Card>
      <CardContent>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} md={3}>
            <DateRangepicker
              startDate={search.startDate}
              endDate={search.endDate}
              handleOnChange={(searchDate) => {
                const updatedFilter = {
                  from: dayjs(searchDate[0].startDate).format("YYYY-MM-DD"),
                  to: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                };
                if (
                  updatedFilter.from !== searchDate.startDate ||
                  updatedFilter.to !== searchDate.endDate
                ) {
                  setSearch({
                    ...search,
                    startDate: dayjs(searchDate[0].startDate).format(
                      "YYYY-MM-DD"
                    ),
                    endDate: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectJItem
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  j_item_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _JItems.filter((x) => x.id === search.j_item_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs="auto" md={1}>
            <Tooltip title="الغاء الفلتر">
              <IconButton
                onClick={() => {
                  setSearch({
                    startDate: dayjs().format("YYYY-MM-01"),
                    endDate: dayjs().format("YYYY-MM-DD"),
                    j_item_id: null,
                  });
                }}
              >
                <MdOutlineClear />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ height: { xs: "auto", md: "80vh" }, width: "100%" }}>
              <ResponsiveDataGrid gridHeight={null}
                rows={
                  _SoldJItems.data?.map((x, index) => ({
                    ...x,
                    index: index + 1,
                  })) ?? []
                }
                loading={loading}
                columns={columns}
                components={{
                  LoadingOverlay: LinearProgress,
                  Toolbar: customToolbar,
                  Footer: CustomFooter,
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default SoldJItems;
